import { Button } from "@components/blocks/Button";
import { PartnerCRMApplication } from "@justhome/common/api/core";
import { Icon, InlineNotification, Title } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";

interface BenefitSectionProps {
  className?: string;
  title: string;
  benefits?: string[];
  ctaText: string;
  hasBackground?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  errorLabel: string;
  termsText?: string;
  onSubmit: (values: PartnerCRMApplication) => void;
  trackingId: string;
  propertyId: string;
}

const BenefitSection: FC<BenefitSectionProps> = ({
  className,
  title,
  benefits,
  ctaText,
  hasBackground = false,
  isLoading = false,
  isError = false,
  errorLabel,
  termsText,
  onSubmit,
  trackingId,
  propertyId,
}) => {
  return (
    <section
      className={clsx(
        {
          "bg-neutral-12 rounded-m border border-neutral-50 drop-shadow-sm p-3s":
            hasBackground,
        },
        className,
      )}
    >
      <div className="grid grid-cols-1 m:grid-cols-2 gap">
        <Title as="h3" className="text-h3 mb-s m:mb-m m:w-min">
          {title}
        </Title>
        {!!benefits && (
          <div className="flex flex-col s:ml-x space-y-2xs">
            {benefits.map((benefitText, index) => (
              <span key={index} className="text-body-2 flex items-center">
                <Icon
                  type="Check"
                  className="text-primary-800 mr-2xs flex-none"
                  size="18"
                />
                {benefitText}
              </span>
            ))}
          </div>
        )}
        <div className="w-full m:col-start-2">
          {isError && (
            <InlineNotification
              className="m:col-span-2 mt-2s mb-s"
              type="error"
            >
              {errorLabel}
            </InlineNotification>
          )}
          <Button
            data-testid="meeting-submit"
            id={trackingId}
            trackingId={trackingId}
            variant="primary"
            label={ctaText}
            className="s:!w-full"
            size="md"
            onClick={() =>
              onSubmit({ propertyId, equity: 0, monthlyNetIncome: 0 })
            }
            isLoading={isLoading}
          />
        </div>
      </div>
      {termsText && (
        <p
          className="text-body-2 m:col-span-2 mt-3s"
          dangerouslySetInnerHTML={{
            __html: termsText,
          }}
        />
      )}
    </section>
  );
};

export default BenefitSection;
